import { SELECTION_TYPES } from "@/schemas/genericSelectionSchema";
import {hotelGuestGeneralValidations} from "./generalValidations";
import { createHotelGuestCustomValidations } from "./customValidations";

/**
 * Otel yolcu seçimi konfigürasyonu
 * i18n desteği ile
 */

// Passenger types for hotel
export const HOTEL_GUEST_TYPES = {
  ADULT: "adult",
  CHILD: "child",
};

/**
 * Otel yolcu seçim konfigürasyonu
 * @param {Object} options - Customization options
 * @param {Number} options.maxPassengers - Maksimum yolcu sayısı
 * @param {Number} options.minPassengers - Minimum yolcu sayısı
 * @param {Object} options.badges - Badge'ler { slug: "badge metni" }
 *   Örnek: { young: "%10 indirim", adult: "Popüler", child: "Ücretsiz" }
 * @returns {Object} Configuration object
 */
export const createHotelGuestConfig = ({
  maxPassengers = 14,
  minPassengers = 1,
  badges = { }, // Default: young'da %10 indirim
} = {}) => {
  const children = [
    {
      type: SELECTION_TYPES.INCREMENT,
      slug: HOTEL_GUEST_TYPES.ADULT,
      labelKey: "hotelSearch.guestAdult",
      label: "Yetişkin",
      descriptionKey: "hotelSearch.guestAdultDesc",
      min: 1, // Yetişkin sayısı minimum 1 olmalı (0 olamaz)
      max: 10,
      value: 1,
      badge: badges?.adult, // Dışardan gelen badge
    },
    {
      type: SELECTION_TYPES.INCREMENT,
      slug: HOTEL_GUEST_TYPES.CHILD,
      labelKey: "hotelSearch.guestChild",
      label: "Çocuk",
      descriptionKey: "hotelSearch.guestChildDesc",
      description: "0-17 yaş",
      min: 0,
      max: 4,
      value: 0,
      badge: badges?.child, // Dışardan gelen badge
    },
  ];

  return {
    settings: {
      totalSelections: maxPassengers,
      minTotalSelections: minPassengers,
      allowZeroSelections: false,
      customValidations: createHotelGuestCustomValidations(HOTEL_GUEST_TYPES),
      generalValidations: hotelGuestGeneralValidations,
      applyValidation: (values) => {
        const childCount = values.child || 0;
        if (childCount > 0) {
          const childrenAges = values.childrenAges || [];
          const validAgesCount = childrenAges.filter(
            (a) => a !== "" && a != null && a !== undefined,
          ).length;
          if (validAgesCount !== childCount) {
            return {
              valid: false,
              general: {
                titleKey: "hotelSearch.childrenAgesRequiredTitle",
                descriptionKey: "hotelSearch.childrenAgesRequiredMessage",
              },
            };
          }
        }
        return { valid: true };
      },
    },
    children: [
      {
        type: SELECTION_TYPES.GROUP,
        //labelKey: "hotel.guestTitle",
        //label: "Konuk Sayısı", // Fallback
        className: "divide-y divide-primary-weak",
        children,
      },
    ],
  };
};

/**
 * Display formatter for bus passengers
 * @param {Object} values - Current values
 * @param {Function} t - Translation function
 * @returns {String} Display text
 */
export const hotelGuestDisplayFormatter = (values, t) => {
  const adultCount = values[HOTEL_GUEST_TYPES.ADULT] || 0;
  const childCount = values[HOTEL_GUEST_TYPES.CHILD] || 0;
  
  const total = adultCount + childCount;

  if (total === 0) {
    return t ? t("guestSelect") : "Misafir Seçin";
  }

  const parts = [];

  if (adultCount > 0) {
    const passengerText = t ? t("guestAdult") : "Yetişkin";
    parts.push(`${adultCount} ${passengerText}`);
  }

  if (childCount > 0) {
    const childText = t ? t("guestChild") : "Çocuk";
    parts.push(`${childCount} ${childText}`);
  }

  return parts.join(", ");
};

/**
 * Varsayılan config
 */
export const defaultHotelGuestConfig = createHotelGuestConfig();

